import React, { memo } from "react";
import { Typography } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";

const Description = ({ desc, companyColor }) => {
    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%' }}>
            <div style={{ display: 'flex', flexWrap: 'wrap', marginRight: 30 }}>
                <Typography className="whiteText" variant="h6" style={{ fontWeight: 100, marginRight: 5, fontSize: '1.1rem' }}>
                    {getLocalizedString("processDescriptionLong")}:
                </Typography>
                <Typography style={{ color: companyColor, fontWeight: 600, fontSize: '1.1rem' }} variant="h6">
                    {desc["Descripción del proceso"] || "-"}
                </Typography>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', marginRight: 30 }}>
                <Typography className="whiteText" variant="h6" style={{ fontWeight: 100, marginRight: 5, fontSize: '1.1rem' }}>
                    {getLocalizedString("processPeriodLong")}:
                </Typography>
                <Typography style={{ color: companyColor, fontWeight: 600, fontSize: '1.1rem' }} variant="h6">
                    {desc["Período del proceso"] || "-"}
                </Typography>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                <Typography className="whiteText" variant="h6" style={{ fontWeight: 100, marginRight: 5, fontSize: '1.1rem' }}>
                    {getLocalizedString("publishedProcess")}:
                </Typography>
                <Typography style={{ color: companyColor, fontWeight: 600, fontSize: '1.1rem' }} variant="h6">
                    {desc["Proceso publicado"] || "-"}
                </Typography>
            </div>
        </div>
    )
}

export default memo(Description);
